/**
 * general application controlling goes here
 */
(function ($) {
  function captchaCallback () {
    console.log('Captcha is ready')
  }

  function ProfilePathwayEvent (e) {
    var tab = window.activityTabSet
    var t = window.profileTabSet

    t.activeTabIndex = 2
    t.switchTabs()

    if (e.data.goTo === 'accelerate') {
      tab.activeTabIndex = 2
    } else if (e.data.goTo === 'act') {
      tab.activeTabIndex = 1
    } else {
      tab.activeTabIndex = 0
    }

    tab.switchTabs()
  }

  function attachProfilePathwayHandlers () {
    var greenSelectors = '.green-outer, .green-inner'
    var yellowSelectors = '.yellow-outer, .yellow-inner'
    var blueSelectors = '.blue-outer, .blue-inner'

    $(greenSelectors).click({goTo: 'analyze'}, ProfilePathwayEvent)
    $(yellowSelectors).click({goTo: 'act'}, ProfilePathwayEvent)
    $(blueSelectors).click({goTo: 'accelerate'}, ProfilePathwayEvent)
  }

  function redirect (selector) {
    if ($(selector).length < 1) {
      return
    }

    var url = ajax.permalink + '/city-profiles/me'
    if (url.length < 1) {
      return
    }

    setTimeout(function () {
      window.location.replace(url)
    }, 4000)
  }

  $(document).ready(function () {
    $('.login-tabset').tabset({
      tabLinks: 'a',
      hide: true,
      show: true,
      defaultTab: true,
      active: 0
    })

    redirect('.redirect.profile')

    attachProfilePathwayHandlers()

    // $('.combobox').multipleSelect()
  })
})(jQuery);
